import { useState, useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { useFormState } from 'utils/hooks';
import FormList from 'common/components/form/FormList';

import Input from 'common/components/form/inputs/Input';
import NumberInput from 'common/components/form/inputs/NumberInput';
import Checkbox from 'common/components/form/inputs/Checkbox';
import { NameSynonym, CodeSynonym } from './Synonym';
import ListSelect from 'common/components/selectors/ListSelect';
import { isLatAllowed } from './helpers';
import { timeZoneOptions } from 'common/utils/fixed';
import Select from 'common/components/form/inputs/Select';
import AsyncSelector from 'common/components/selectors/AsyncSelector';
import { getAsyncOptions, getInitialAsyncValues } from 'utils/helpers';

const Port = ({ formState }) => {
  const { fields, changeField, selectField, setFieldValue, subStates, addSubform, removeSubform } =
    useFormState(formState);

  const [synonymNameIndex, setSynonymNameIndex] = useState(0);
  const [synonymCodeIndex, setSynonymCodeIndex] = useState(0);

  const isLonAllowed = ({ floatValue }) => {
    return floatValue ? floatValue <= 180 && floatValue >= -180 : true;
  };

  useEffect(() => {
    setSynonymNameIndex(0);
    setSynonymCodeIndex(0);
  }, []);

  return (
    <div className="edit-port pe-3">
      <Row className="no-gutters">
        <Col className="pe-3">
          <Input label="Name" onChange={changeField('name')} {...fields.name} />
        </Col>

        <Col>
          <div className="d-flex flex-column">
            <h2 className="form-label">Name Synonym{synonymNameIndex >= 1 && 's'}</h2>

            <FormList
              inner
              showBin={true}
              sideBin={true}
              forms={subStates(`synonymsName`)}
              className="w-100p pt-0 add-button-form-list-vessels-synonyms outside"
              formListclassName="bg-white"
              onAdd={() => addSubform('synonymsName', { show_in_position_list: true })}
              onRemove={index => {
                setSynonymNameIndex(synonymNameIndex - 1);
                removeSubform('synonymsName', index);
              }}
              addText={'Add more'}
            >
              {formState => <NameSynonym setSynonymIndex={setSynonymNameIndex} state={formState} />}
            </FormList>
          </div>
        </Col>
      </Row>

      <Row className="no-gutters code-synonyms">
        <Col className="pe-3">
          <Input label="Code" onChange={changeField('code')} {...fields.code} />
        </Col>

        <Col>
          <div className="d-flex flex-column">
            <h2 className="form-label">Code Synonym{synonymCodeIndex >= 1 && 's'}</h2>
            <FormList
              inner
              showBin={true}
              sideBin={true}
              forms={subStates(`synonymsCode`)}
              className="w-100p pt-0 add-button-form-list-vessels-synonyms outside"
              formListclassName="bg-white"
              onAdd={() => addSubform('synonymsCode', { show_in_position_list: true })}
              onRemove={index => {
                setSynonymCodeIndex(synonymCodeIndex - 1);
                removeSubform('synonymsCode', index);
              }}
              addText={'Add more'}
            >
              {formState => <CodeSynonym setSynonymIndex={setSynonymCodeIndex} state={formState} />}
            </FormList>
          </div>
        </Col>
      </Row>

      <Row className="no-gutters">
        <Col className="pe-1">
          <Select
            placeholder="Select timezone"
            label={'Timezone'}
            options={timeZoneOptions}
            onChange={selectField('timezone')}
            className="mb-0"
            {...fields?.timezone}
          />
        </Col>

        <Col className="pe-1">
          <NumberInput
            label="Latitude"
            isAllowed={isLatAllowed}
            decimalScale={9}
            onChange={changeField('lat')}
            {...fields.lat}
          />
        </Col>
        <Col>
          <NumberInput
            label="Longitude"
            isAllowed={isLonAllowed}
            decimalScale={9}
            onChange={changeField('lon')}
            {...fields.lon}
          />
        </Col>
      </Row>

      <Row className="no-gutters">
        <Col className="pe-1">
          <ListSelect
            list="port-areas"
            label="Area"
            onChange={selectField('port_area_id')}
            {...fields.port_area_id}
          />
        </Col>

        <Col>
          <NumberInput
            label="Max Sulfur (%)"
            onChange={changeField('max_sulfur')}
            {...fields.max_sulfur}
          />
        </Col>
      </Row>

      <Row className="no-gutters">
        <Col>
          <Checkbox
            label="Bunkering port"
            value={fields.is_bunkering.value}
            onChange={() => setFieldValue('is_bunkering', !fields.is_bunkering.value)}
          />
        </Col>
      </Row>

      <Row className="no-gutters">
        <Col>
          <AsyncSelector
            type="countries"
            label="COUNTRY"
            onChange={e => selectField('country')(e)}
            placeholder="Select country"
            getOptionValue={option => option.id}
            getOptionLabel={option => option.name}
            loadOptions={search => getAsyncOptions(search, 'countries')}
            defaultOptions={() => getInitialAsyncValues('countries')}
            {...fields.country}
          />
        </Col>
      </Row>

      <Row className="no-gutters">
        <Col className="pe-1">
          <AsyncSelector
            type="port-types"
            label={'type'}
            onChange={selectField('type')}
            placeholder={'Select type'}
            getOptionValue={option => option.id}
            getOptionLabel={option => option.name}
            {...fields.type}
          />
        </Col>
        <Col>
          <AsyncSelector
            type="port-sizes"
            placeholder="Select size"
            label={'Size'}
            onChange={selectField('size')}
            className="mb-0"
            getOptionValue={option => option.id}
            getOptionLabel={option => option.name}
            isClearable
            {...fields?.size}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Port;
